const data = {
  id: 1,
  title: 'Choose the correct answer to fill in the blank.',
  subTitle: 'Chọn từ chính xác điền vào chỗ trống.',
  question: '___ crocodiles.',
  answers: [
    { id: 1, answer: "They're", isCorrect: false },
    { id: 2, answer: 'This is', isCorrect: true },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      // direction: 'vertical',
      bulletType:'none'
    },
  },
};

export default data;
